import {Navbar, Nav, NavItem, Container, NavLink} from "react-bootstrap";
import { useAuth } from "./AuthContext";
import logo from "./gain-line-ascot.png";

const MyNavbar = () => {
    const { loggedIn, logout, isAdmin} = useAuth();

    return (
        <Navbar expand="lg" className="py-2 bg-body-tertiary border-bottom sticky-top">
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src={logo}
                        alt="Leaderboard Logo"
                        height="40" // Adjust size as needed
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Navbar.Toggle className="ms-auto" aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    {/*<NavItem>*/}
                    {/*    <NavLink href="/competitions" className="link-body-emphasis px-2">Competitions</NavLink>*/}
                    {/*</NavItem>*/}
                    <NavItem>
                        <NavLink href="/leaderboard" className="link-body-emphasis px-2 fs-6">Leaderboard</NavLink>
                    </NavItem>
                    {/*<NavItem>*/}
                    {/*    <NavLink href="/workouts" className="link-body-emphasis px-2">Explore Workouts</NavLink>*/}
                    {/*</NavItem>*/}
                    <NavItem>
                        <NavLink href="/profile" className="link-body-emphasis px-2 fs-6">Profile</NavLink>
                    </NavItem>
                    {isAdmin() ?
                        <NavItem>
                            <NavLink href="/admin" className="link-body-emphasis px-2 fs-6">Admin Portal</NavLink>
                        </NavItem> : null
                    }
                </Nav>
                    <Nav className="ms-auto">
                        <NavItem>
                            {loggedIn ? (
                                <NavLink href="/login" onClick={logout} className="link-body-emphasis px-2 active fs-6">Logout</NavLink>
                            ) : (
                                <NavLink href="/login" className="link-body-emphasis px-2 active fs-6">Login</NavLink>
                            )}
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default MyNavbar;